module.exports = __webpack_public_path__ + "img/pager4img.f635b988.png";